export const messages = {
  en: {
    supplierCouponBuy: {
      searchTitle: 'Query Conditions',
      listTitle: 'Coupon Purchase Records',
      placeholder: {
        buyId: 'Order Number',
        couponId: 'Coupon ID',
        name: 'Name',
        supplierName: 'Supplier',
        storeName: 'Store Name',
        objName: 'Community Name',
        createUserTel: 'Contact Info',
        createUserName: 'Buyer'
      },
      table: {
        buyId: 'ID',
        couponName: 'Coupon',
        name: 'Name',
        supplierName: 'Supplier',
        quantity: 'Quantity',
        valuePrice: 'Price',
        storeName: 'Store Name',
        objName: 'Community Name',
        createUserTel: 'Contact',
        createUserName: 'Buyer',
        remark: 'Remark'
      },
      fetchError: 'Failed to fetch coupon purchase records'
    }
  },
  zh: {
    supplierCouponBuy: {
      searchTitle: '查询条件',
      listTitle: '优惠券购买记录',
      placeholder: {
        buyId: '请填写订单号',
        couponId: '请填写优惠券编号',
        name: '请填写名称',
        supplierName: '请填写供应商',
        storeName: '请填写商户名称',
        objName: '请填写小区名称',
        createUserTel: '请填写联系方式',
        createUserName: '请填写购买人'
      },
      table: {
        buyId: '编号',
        couponName: '优惠券',
        name: '名称',
        supplierName: '供应商',
        quantity: '购买数量',
        valuePrice: '售价',
        storeName: '商户名称',
        objName: '小区名称',
        createUserTel: '联系方式',
        createUserName: '购买人',
        remark: '备注'
      },
fetchError: '獲取優惠券購買記錄失敗'
    }
  },
  'zh-TW': {
    supplierCouponBuy: {
      searchTitle: '查詢條件',
      listTitle: '優惠券購買記錄',
      placeholder: {
        buyId: '請填寫訂單號',
        couponId: '請填寫優惠券編號',
        name: '請填寫名稱',
        supplierName: '請填寫供應商',
        storeName: '請填寫商戶名稱',
        objName: '請填寫小區名稱',
        createUserTel: '請填寫聯繫方式',
        createUserName: '請填寫購買人'
      },
      table: {
        buyId: '編號',
        couponName: '優惠券',
        name: '名稱',
        supplierName: '供應商',
        quantity: '購買數量',
        valuePrice: '售價',
        storeName: '商戶名稱',
        objName: '小區名稱',
        createUserTel: '聯繫方式',
        createUserName: '購買人',
        remark: '備註'
      },
      fetchError: '獲取優惠券購買記錄失敗'
    }
  }
}